import axios from 'axios';
import type { AuthResponse, LoginCredentials, RegisterData, User } from './types';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:8080/api/v1';

// ── Tipos del panel DEV ──────────────────────────────────────────────────────

export interface DevProject {
  id: string;
  name: string;
  role: string;
}

export interface DevUser {
  userId: string;
  email: string;
  displayName: string;
  roleName: string;
  tenantName: string;
  isSuperAdmin: boolean;
  projects: DevProject[];
}
// ────────────────────────────────────────────────────────────────────────────

/**
 * Cliente API para autenticación
 */
export const authApi = {
  /**
   * Login de usuario
   */
  async login(credentials: LoginCredentials): Promise<AuthResponse> {
    const response = await axios.post<AuthResponse>(`${API_URL}/auth/login`, credentials);
    return response.data;
  },

  /**
   * Registro de nuevo usuario
   */
  async register(data: RegisterData): Promise<AuthResponse> {
    const response = await axios.post<AuthResponse>(`${API_URL}/auth/register`, data);
    return response.data;
  },

  /**
   * [DEV] Lista usuarios con proyectos asignados.
   * Solo disponible cuando el backend corre en NODE_ENV=development.
   */
  async getDevUsers(): Promise<DevUser[]> {
    const response = await axios.get<DevUser[]>(`${API_URL}/auth/dev/users-with-projects`);
    return response.data;
  },

  /**
   * [DEV] Login rápido por userId sin contraseña.
   * Solo disponible cuando el backend corre en NODE_ENV=development.
   */
  async devQuickLogin(userId: string): Promise<AuthResponse> {
    const response = await axios.post<AuthResponse>(`${API_URL}/auth/dev/quick-login`, { userId });
    return response.data;
  },

  /**
   * Obtener usuario actual
   */
  async me(token: string): Promise<User> {
    // [TEMP] Log del token usado
    console.log('[AUTH-DEBUG] authApi.me() - enviando request con token:', {
      tokenPrefix: token.substring(0, 20) + '...',
      tokenLength: token.length,
      hasBearer: true,
    });
    const response = await axios.get<User>(`${API_URL}/auth/me`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  },
};
